export default "__VITE_ASSET__BeabtVy3__"